<template>
    <el-form style="height:650px" ref="form" label-width="180px" :rules="rules" :model="dioForm">
        <el-row :gutter="15">
            <el-col :span="12">
                <el-form-item :label="$t('user.name')" prop="username">
                    <el-input v-model.trim="dioForm.username" style="width: 250px"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item :label="$t('user.account')" prop="account">
                    <!-- 用户账户优化为文本展示 编辑状态account不允许进行编辑 -->

                    <template v-if="editObj">
                        {{ editObj.account }}
                    </template>
                    <template v-else>
                        <el-input v-model.trim="dioForm.account" style="width: 250px"></el-input>
                    </template>

                    <i class="el-icon-back" @click="handleMode" style="float:right;color:#000" v-show="dioForm.id"></i>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :span="12">
                <el-form-item :label="$t('public.phone_num')" prop="mobile">
                    <el-input v-model.trim="dioForm.mobile" style="width: 250px"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item :label="$t('public.email')" prop="email">
                    <el-input v-model.trim="dioForm.email" style="width: 250px"></el-input>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :span="12">
                <el-form-item :label="$t('user.status')" prop="status">
                    <el-select v-model="dioForm.status" style="width:250px">
                        <el-option v-for="item in statusArray.slice(1)" :key="item.value" :value="item.value" :label="$t(item.label)"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <!--<el-col :span="12">-->
            <!--    <el-form-item :label="$t('user.gender')" prop="gender">-->
            <!--        <el-radio-group v-model="dioForm.gender">-->
            <!--            <el-radio :label="1">{{ $t('integration.male') }}</el-radio>-->
            <!--            <el-radio :label="0">{{ $t('integration.female') }}</el-radio>-->
            <!--        </el-radio-group>-->
            <!--    </el-form-item>-->
            <!--</el-col>-->
        </el-row>

        <el-form-item :label="$t('user.type')" prop="roleType">
            <el-select v-model="dioForm.roleType" style="width:250px" @change="changeRoleType">
                <el-option v-for="item in roleTypeArray.slice(1)" :key="item.value" :value="item.value" :label="$t(item.label)"> </el-option>
            </el-select>
        </el-form-item>
        <!-- 如果非平台 则影藏 -->
        <template v-if="$store.state.type === 3 || $store.state.type === 2">
            <el-form-item :label="$t('public.table_scope')" prop="customerId" v-if="isProxyType">
                <el-select v-model="dioForm.customerId" style="width:250px" @change="changeCustomer" v-if="isPingTaiAdmin">
                    <!--  是否平台类型角色 -->
                    <el-option v-for="item in customerArray" :key="item.id" :value="item.id" :label="$t(item.name)"></el-option>
                </el-select>
                <span v-else>{{ customerArray.length > 0 ? customerArray[0].name : '' }}</span>
            </el-form-item>
        </template>
        <!-- 角色 -->
        <el-row>
            <el-col :span="12">
                <el-form-item :label="$t('user.role')" prop="roleId">
                    <el-select @change="roleChange" v-model="dioForm.roleId" style="width:250px;margin-right:15px">
                        <el-option v-for="item in roleArray" :key="item.id" :value="item.id" :label="$t(item.name)"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12" v-if="!isProxyType">
                <el-form-item :label="$t('user.governing_customers')" prop="proxySenceId">
                    <el-select v-model="proxySenceId" style="width:250px;margin-right:15px" @change="proxyFn">
                        <el-option v-for="item in ProxyArray" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-form-item
            :label="$t('user.associated_architecture')"
            prop="sceneIds"
            :rules="[
                {
                    required: !isProxyType,
                    validator: treeCheck,
                    trigger: 'blur'
                }
            ]"
        >
            <div class="treeClass" v-loading="loadingTree">
                <el-tree
                    :props="props"
                    :data="StructureArray"
                    :show-checkbox="isEdit"
                    @check-change="handleCheckChange"
                    ref="tree"
                    node-key="scene_id"
                    :default-checked-keys="defaultKeys"
                    :default-expanded-keys="defaultKeys"
                >
                </el-tree>
            </div>
        </el-form-item>

        <el-form-item :label="$t('user.btn_sync_contact')" prop="syncContact">
            <el-checkbox v-model="dioForm.syncContact" :true-label="1" :false-label="0"></el-checkbox>
        </el-form-item>
    </el-form>
</template>

<script>
import { accountCustomer, accountRole, accountStructure } from '@/api/modules/userInfo.js';
export default {
    props: ['statusArray', 'roleTypeArray', 'editObj', 'customerArrayDetail', 'loadingeditTree', 'editStructureArray', 'roleArrayEdit'],
    computed: {
        rules() {
            return {
                username: [
                    { required: true, message: this.$t('validate.user_name_required'), trigger: 'blur' },
                    {
                        max: 50,
                        message: this.$t('validate.len_50'),
                        trigger: 'blur'
                    }
                ],
                account: [
                    { required: true, message: this.$t('validate.user_account_required'), trigger: 'blur' },
                    {
                        max: 20,
                        message: this.$t('validate.len_20'),
                        trigger: 'blur'
                    }
                ],
                roleId: [{ required: true, message: this.$t('validate.user_role_required'), trigger: 'change' }],
                mobile: [
                    { required: true, message: this.$t('validate.user_mobile_required'), trigger: 'blur' },
                    {
                        max: 20,
                        message: this.$t('validate.len_20'),
                        trigger: 'blur'
                    },

                ],
                email: [
                    { required: true, message: this.$t('validate.email_required'), trigger: 'blur' },
                    {
                        max: 255,
                        trigger: 'blur',
                        message: this.$t('validate.len_255')
                    },
                    {
                        type: 'email',
                        message: this.$t('validate.email_format'),
                        trigger: ['blur', 'change']
                    }
                ],
                roleType: [{ required: true, message: this.$t('validate.user_role_type_required'), trigger: 'change' }]
            };
        }
    },
    watch: {
        editObj(newVal) {
            // 判断是否为平台
            if (newVal.roleType === 2 || newVal.roleType === 3) {
                this.isPingTaiAdmin = false;
            } else {
                this.isPingTaiAdmin = true;
            }

            // 判断是否是代理类型
            if (newVal.roleType === -1) {
                this.isProxyType = false;
            } else {
                this.isProxyType = true;
                this.scope = '';
            }

            // 判断是否开启架构的check框

            if (newVal.roleType === 0) {
                this.isEdit = true;
            } else {
                this.isEdit = false;
            }
            this.dioForm = { ...newVal };
            if (this.dioForm.roleStatus == 0) {
                this.dioForm.roleId = '';
            }
            if (this.dioForm.customerStatus == 0) {
                this.dioForm.customerId = '';
            }
            this.$set(this.dioForm, 'syncContact', 0);
            this.proxySenceId = newVal.scopeId;
            // this.ProxyArray = [...newVal.customers]
        },
        roleArrayEdit(newVal) {
            this.roleArray = [...newVal] || [];
            this.roleArray.forEach(item => {
                if (item.id === this.editObj.roleId) {
                    this.ProxyArray = item.scope;
                }
            });
            console.log(this.ProxyArray);
        },

        customerArrayDetail(newVal) {
            this.customerArray = [...newVal];
        },
        loadingeditTree(newVal) {
            this.loadingTree = newVal;
        },
        editStructureArray(newVal) {
            this.defaultKeys = [];
            let newArray = [];
            this.defaultKeys = this.TODODEEPTREE([...newVal], newArray);
            this.StructureArray = [...newVal];
        }
    },
    data() {
        return {
            dioForm: {
                username: '',
                account: '',
                mobile: '',
                email: '',
                status: 1,
                gender: 1,
                roleType: '',
                customerId: '',
                roleId: '',
                sceneIds: [],
                syncContact: 0
            },
            customerArray: [],
            roleArray: [],
            // 代理范围
            ProxyArray: [],
            // 是否平台类型
            isPingTaiAdmin: true,
            // 是否代理类型
            isProxyType: true,
            // 是否为客户管理
            isCustomer: true,
            StructureArray: [],
            defaultKeys: [],
            props: {
                label: 'label',
                children: 'item'
            },
            loadingTree: false,
            // 是否暂时check
            isEdit: false,
            // 管辖范围
            proxySenceId: '',
            scope: ''
        };
    },

    methods: {
        /** 递归遍历树获取选中的id */
        TODODEEPTREE(array = [], newArray) {
            array.forEach(option => {
                if (option.level !== 0 && option.check === 1) {
                    newArray.push(option.scene_id);
                } else {
                    if (option.item.length > 0) {
                        this.TODODEEPTREE(option.item, newArray);
                    }
                }
            });
            return newArray;
        },
        handleMode() {
            this.$emit('goBack');
        },
        resetInitData() {
            this.isProxyType = true;
            this.StructureArray = [];
            this.defaultKeys = [];
            this.clearValidate();
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        treeCheck(rule, value, callback) {
            if (this.dioForm.roleType === 0 && this.dioForm.sceneIds.length === 0) {
                callback(this.$t('validate.user_archit_required'));
            } else {
                callback();
            }
        },

        /** 角色类型 */
        async changeRoleType(id) {
            this.$refs.form.clearValidate('roleId');
            this.dioForm.customerId = '';
            this.dioForm.roleId = '';
            this.roleArray = [];

            // 判断是否为平台
            if (id === 2 || id === 3) {
                this.isPingTaiAdmin = false;
            } else {
                this.isPingTaiAdmin = true;
            }

            // 判断是否是代理类型
            if (id === -1) {
                this.isProxyType = false;
            } else {
                this.isProxyType = true;
                this.scope = '';
            }

            // 判断是否开启架构的check框

            if (id === 0) {
                this.isEdit = true;
            } else {
                this.isEdit = false;
            }

            // 选择角色类型 -> 客户（默认提取第一条数据，如果为代理角色客户隐藏） -> 角色（默认提取第一条数据）-> 架构
            if (id !== -1) {
                let { result } = await accountCustomer({ type: id });
                this.customerArray = result;
                this.dioForm.customerId = result.length > 0 ? result[0].id : '';
            }

            // 角色
            let { result } = await accountRole({
                type: id,
                customerId: this.dioForm.customerId || null
            });

            this.roleArray = result;
            // 如果为代理  则填充
            if (id === -1) {
                this.proxySenceId = result.length > 0 ? result[0].scope[0].id : '';
                this.ProxyArray = result.length > 0 ? result[0].scope : '';
                this.scope = result.length > 0 ? result[0].scope[0].id : '';
            } else {
                this.ProxyArray = [];
                this.scope = '';
            }

            if (result.length > 0) {
                this.dioForm.roleId = result.length > 0 ? result[0].id : '';
            } else {
                this.dioForm.roleId = '';
            }

            // 架构

            this.getStructure();

            if (this.$refs['form']) {
                this.$refs['form'].clearValidate();
            }
        },
        /** 客户选择 */
        async changeCustomer(id) {
            this.dioForm.roleId = '';

            await accountRole({ type: this.dioForm.roleType, customerId: id }).then(({ result }) => {
                this.roleArray = result;
                if (result.length > 0) {
                    this.dioForm.roleId = result[0].id;
                } else {
                    this.dioForm.roleId = '';
                }
            });

            this.getStructure();
        },
        /** 角色选择 */
        roleChange(id) {
            /** 如果是 */
            if (this.dioForm.roleType !== -1) return;
            this.roleArray.forEach(item => {
                if (item.id === id) {
                    this.ProxyArray = item.scope;
                    this.proxySenceId = item.scope[0].id;
                }
            });
            this.scope = this.proxySenceId;
            this.getStructure();
        },
        /** 管辖范围 */
        proxyFn(id) {
            this.scope = id;
            this.getStructure();
        },
        /** 获取架构树 */
        getStructure() {
            this.loadingTree = true;
            const { roleType, customerId } = this.dioForm;
            let query = {
                type: roleType,
                // this.isEdit ? 1 : 0
                isEdit: 1,
                // 这里注意一下   两个字段都是代表范围  但是却要根据是否是代理来分开使用
                customerId: customerId || null,
                scope: this.scope || null
            };
            accountStructure(query)
                .then(({ result }) => {
                    this.StructureArray = result.item;
                })
                .finally(() => {
                    this.loadingTree = false;
                });
        },
        /** 勾选架构树 */
        handleCheckChange() {
            // let array = Array.prototype.slice.call(arguments);
            //    console.log(array);
            //    返回半选
            let HalfCheckedNode = this.$refs['tree'].getHalfCheckedNodes();
            let CheckedNodes = this.$refs['tree'].getCheckedNodes();
            // console.log('半选==>', HalfCheckedNode);
            // console.log('全选==>', CheckedNodes);

            let senceArray = HalfCheckedNode.map(item => item.sceneId || item.scopeId);
            let jiagouArray = CheckedNodes.map(item => item.sceneId || item.scopeId);

            this.dioForm.sceneIds = [...senceArray, ...jiagouArray];
        }
    }
};
</script>

<style lang="scss" scoped>
.treeClass {
    height: 300px;
    overflow: auto;
    border: 1px solid #e7e7e7;
    padding: 10px 0;
    box-sizing: border-box;
}
</style>
